import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ViewModal = ({ id, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.id === id);

  const [activeTab, setActiveTab] = useState("1");

  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }`;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white p-2 rounded-md"
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <CommonCloseBtn
            onClose={() => {
              setActiveTab("1");
              closeModal();
            }}
          />
          <h2 className="text-center font-bold text-lg">Subuser Details</h2>

          {/* Tab Content */}
          <div className="p-4 max-h-96 overflow-y-auto">
            {activeTab === "1" && (
              <div
                className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm"
                style={{ maxHeight: "400px" }}
              >
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Name
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.username}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Email
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.email}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Agent Email
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20 break-words whitespace-normal">
                      {result?.agent_email}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Agent Reference
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20 break-words whitespace-normal">
                      {result?.agent_reference}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Reference User
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20 break-words whitespace-normal">
                      {result?.reference_user}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Role Name
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20 break-words whitespace-normal">
                      {result?.role_name}
                    </dd>
                  </div>
                </dl>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
